/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { Grid, Typography, Checkbox } from '@material-ui/core';
import {
    TextField,
    FormControl,
    Button,
    FormControlLabel,
    Menu,
    MenuItem,
    Select,
    FormHelperText,
    Tooltip,
    IconButton,
    Autocomplete,
    Switch,

} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp, Close, InfoOutlined, Start } from '@mui/icons-material';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSelector } from 'react-redux';

import useStyles from './styles';
import schema from '../../validations/createNotification';
import uploadSVG from '../../assets/images/upload.svg';
import { saveNotification, specificNotification } from '../../redux/Actions/notificaton.action';
import Publish from './Publish';

const CreateNotification = (props) => {
    const history = useHistory();
    const instanceData = useSelector((state) => state.instance.allClients);

    const classes = useStyles();
    const [scheduleAnchorEl, setScheduleAnchorEl] = useState(null);
    const [notificationIcon, setNotificationIcon] = useState(null);
    const [modalButtonLoading, setModalButtonLoading] = useState(false);
    const [publishModal, setPublishModal] = useState(false);
    const [savedScheduleDate, setSavedScheduleDate] = useState(null);
    const [fileName, setFileName] = useState('');
    const [tenants, setTenants] = useState([]);
    const [buttonLoading, setButtonLoading] = useState(false);
    const uploadFileRef = useRef(null);
    const [notificationStatus, setNotificationStatus] = useState();
    const [savedIcon, setSavedIcon] = useState('');
    const { feature6Url, notificationToken } = useSelector((state) => state.constants.settings);

    const open = Boolean(scheduleAnchorEl);

    const handleSchedulePopupClick = (event) => {
        event.stopPropagation();
        setScheduleAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => setScheduleAnchorEl(null);

    const handleFileClick = () => {
        uploadFileRef.current.click();
    };

    const checkFileSize = (file) => new Promise((resolve) => {
        const reader = new FileReader();
    
        if (!file || !file.type.startsWith('image/')) {
            resolve(false);
            return;
        }
    
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                console.log('>>>im', image.width, image.height, file.size < 2 * 1024);
                resolve(image.width <= 80 && image.height <= 80);
            };
            image.src = event.target.result;
        };
    
        reader.readAsDataURL(file);
    });

    const handleFileChange = async (event) => {
        const fileList = event.target.files;
        const file = fileList[0];

        setFileName(file.name);

        if (file) {
            const sizeResponse = await checkFileSize(file);
            setNotificationIcon(file);

            if (sizeResponse) {
                notificationFormik.setFieldValue('thumbnailUrl', file.name);
                notificationFormik.setFieldError('thumbnailUrl', '');
                notificationFormik.setFieldValue('error', 0);
            }
            else {
                notificationFormik.setFieldError('thumbnailUrl', 'Wrong file format');
                notificationFormik.setFieldValue('error', 1);
            };

            notificationFormik.setFieldValue('fileType', file.type);
        }
        else {
            notificationFormik.setFieldError('thumbnailUrl', 'Wrong file format');
            notificationFormik.setFieldValue('error', 1);
            notificationFormik.setFieldValue('fileType', '');
        };
        event.target.value = null;
    };

    const getFormData = (values) => {
        const formData = new FormData();

        formData.append('title', values.title ? values.title.trim() : '');
        formData.append('description', values.description ? values.description.trim() : '');
        formData.append('priority', values.priority ? 1 : 0);
        formData.append('appId', values.product);

        if (props.match && props.match.params && props.match.params.id) {
            formData.append('id', props.match.params.id);
        }

        if (notificationIcon) formData.append('notificationIcon', notificationIcon);
        if(values.thumbnailUrl && values.thumbnailUrl.length) formData.append('thumbnailUrl', savedIcon);

        if (values.redirectionUrl && values.redirectionUrl.length) formData.append('redirectionUrl', values.redirectionUrl.trim());
        if (values.videoUrl && values.videoUrl.length) formData.append('videoUrl', values.videoUrl.trim());
        if (values.clients && values.clients.length) formData.append('clients', JSON.stringify(values.clients.map(item => item.id)))
        formData.append('sendEmail', values.sendEmail ? 'true' : 'false');
        if (values.sendEmail && values.emailBody) formData.append('emailBody', values.emailBody.trim());
        formData.append('bannerEnabled', values.bannerEnabled ? 'true' : 'false');

        return formData;
    };

    const handleTenantChange = (value) => {
        const allOptions = tenants.slice(1);
        if (value.some(option => option.id === 0)) {
            if (tenants.length - 1 === notificationFormik.values.clients.length) {
                notificationFormik.setFieldValue('clients', []);
            } else {
                notificationFormik.setFieldValue('clients', allOptions);
            }
        } else {
            notificationFormik.setFieldValue('clients', value);
        }
    };

    const notificationFormik = useFormik({
        validateOnMount: true,
        initialValues: {
            title: '',
            description: '',
            product: 0,
            priority: false,
            redirectionUrl: '',
            videoUrl: '',
            thumbnailUrl: '',
            clients: [],
            error: 0,
            fileType: '',
            sendEmail: false,
            emailBody: '',
            bannerEnabled: false,
        },
        onSubmit: (values) => {
            setButtonLoading(true);
            const formData = getFormData(values);
            formData.append('publishAt', new Date().toISOString());
            formData.append('preview', 1);
            formData.append('status', 0);

            saveNotification(formData, notificationToken).then(() => {
                notificationFormik.resetForm();
                setScheduleAnchorEl(null);
                setPublishModal(false);
                setButtonLoading(false);

                window.open(`${feature6Url}/${values.product === 2 ? 'knowbler': ''}`);
                history.goBack();
            });
        },
        validationSchema: schema,
    });

    const publishNowNotification = (publishAt, selectedOption) => {
        setModalButtonLoading(true);
        const formData = getFormData(notificationFormik.values);

        formData.append('publishAt', ['publish', 'draft'].includes(selectedOption) ? new Date().toISOString() : publishAt);

        formData.append('preview', 0);
        formData.append('status', ['publish', 'schedule'].includes(selectedOption) ? 1 : 0);

        saveNotification(formData, notificationToken).then(() => {
            notificationFormik.resetForm();
            setScheduleAnchorEl(null);
            setPublishModal(false);

            if (formData.get('id')) {
                toast.success('Notification Updated Successfully');
            }
            else {
                toast.success(`Notification ${selectedOption === 'schedule' ? 'Schedule' : 'Published'} Successfully`);
            };

            setModalButtonLoading(false);
            history.goBack();
        });
    };

    const removeNotificationIcon = (event) => {
        event.stopPropagation();

        setNotificationIcon(null);
        setFileName('');
        notificationFormik.setFieldValue('thumbnailUrl', '');
        notificationFormik.setFieldValue('error', 0);
        notificationFormik.setFieldValue('fileType', undefined);
    };

    useEffect(() => {
        if (props.match && props.match.params && props.match.params.id) {
            specificNotification(props.match.params.id, notificationToken).then(res => {
                const { notification } = res;

                setNotificationStatus(notification.status);

                let filename = '';
                let fileType = '';

                if (notification.thumbnailUrl && notification.thumbnailUrl.length) {
                    const urlObject = new URL(notification.thumbnailUrl);
                    filename = decodeURIComponent(urlObject.pathname.split('/').pop());
                    
                    const fileExtension = filename.split('.').pop();
                    setSavedIcon(notification.thumbnailUrl.replace(/ /g, '%20'));
                    fileType = `image/${fileExtension}`;
                }
                let temp = notification.clients.map(item => ({ label: item.name, id: item.tenantId }));
                temp = new Array(150).fill({ ...temp[0] });

                notificationFormik.setValues({
                    title: notification.title,
                    description: notification.description,
                    product: notification.appId,
                    priority: notification.priority === 1,
                    redirectionUrl: notification.redirectionUrl || '',
                    videoUrl: notification.videoUrl || '',
                    thumbnailUrl: filename,
                    fileType,
                    clients: notification.clients.map(item => ({ label: item.name, id: item.tenantId })),
                    sendEmail: notification.sendEmail || false,
                    emailBody: notification.emailBody || '',
                    bannerEnabled: notification.bannerEnabled || false,
                });

                setFileName(filename);

                setSavedScheduleDate(notification.publishAt);
            });
        }
    }, [props.match.params, instanceData]);

    useEffect(() => {
        if (instanceData && instanceData.length) {
            let tenants = instanceData[0].clients.map(item => ({ label: item.name, id: item.tenantId }));

            tenants = [{ label: 'Select All', id: 0 }, ...tenants];

            setTenants(tenants);
        }
    }, [instanceData]);

    return (
        <div>
            <Typography variant="h1" className={classes.addNotificationHeading}>
                {props.match.params && props.match.params.id ? 'Edit Notification' : 'Add a Notification'}
            </Typography>

            <div className={classes.notificationContainer}>
                <form>
                    <Grid spacing={2} container>
                        <Grid item xs={12} sm={12} lg={6} columns={3}>
                            <FormControl fullWidth className={classes.inputContainer}>
                                <span className={classes.fieldLabels}>Title*</span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder='Enter Title'
                                    name='title'
                                    className={classes.field}
                                    value={notificationFormik.values.title}
                                    onChange={notificationFormik.handleChange}
                                    onBlur={notificationFormik.handleBlur}
                                    error={notificationFormik.touched.title && notificationFormik.errors.title}
                                    inputProps={{ maxLength: 100, className: classes.field }}
                                />
                                {
                                    notificationFormik.touched.title && notificationFormik.errors.title ? (
                                        <FormHelperText className={classes.inputError}>
                                            {notificationFormik.touched.title && notificationFormik.errors.title}
                                        </FormHelperText>
                                    ) : null
                                }
                            </FormControl>
                            <div>
                                <div className={classes.uploadIconContainer}>
                                    <span className={classes.fieldLabels}>Upload Icon</span>
                                    <Tooltip placement='right' title="Icon size maximum 80x80 px in png, jpg or jpeg format for Knowbler and svg or png for searchunify">
                                        <InfoOutlined fontSize='small' />
                                    </Tooltip>
                                </div>
                                <button
                                    type="button"
                                    className={`${classes.uploadField} ${notificationFormik.errors.thumbnailUrl ? classes.uploadErrorField : ''}`}
                                    onClick={handleFileClick}
                                >
                                    <p>
                                        {fileName.length ? fileName : 'Upload File'}
                                    </p>

                                    <div className={classes.uploadButtonGroup}>
                                        {notificationIcon || notificationFormik.values.thumbnailUrl.length ?
                                            <Close onClick={removeNotificationIcon} style={{ cursor: 'pointer' }} /> : null}
                                        <img alt="preview" src={uploadSVG} style={{ cursor: 'pointer' }} />
                                    </div>
                                </button>
                                <input
                                    type="file"
                                    className={classes.fileUpload}
                                    ref={uploadFileRef}
                                    onChange={handleFileChange}
                                    accept='image/svg+xml, image/png, image/jpeg, image/jpg'
                                />
                                {
                                    notificationFormik.errors.thumbnailUrl ? (
                                        <FormHelperText className={classes.inputError}>
                                            {notificationFormik.errors.thumbnailUrl}
                                        </FormHelperText>
                                    ) : null
                                }
                            </div>
                            <FormControl fullWidth className={classes.inputContainer}>
                                <span className={classes.fieldLabels}>Redirection Url</span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder='Enter URL'
                                    className={classes.textBorderColor}
                                    value={notificationFormik.values.redirectionUrl}
                                    onChange={notificationFormik.handleChange}
                                    onBlur={notificationFormik.handleBlur}
                                    error={notificationFormik.touched.redirectionUrl && notificationFormik.errors.redirectionUrl}
                                    name="redirectionUrl"
                                    sx={{ marginTop: '4px' }}

                                />
                                {
                                    notificationFormik.touched.redirectionUrl && notificationFormik.errors.redirectionUrl ? (
                                        <FormHelperText className={classes.inputError}>
                                            {notificationFormik.touched.redirectionUrl && notificationFormik.errors.redirectionUrl}
                                        </FormHelperText>
                                    ) : null
                                }

                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} lg={6} columns={3}>
                            <FormControl fullWidth>
                                <span className={`${classes.fieldLabels} ${classes.descriptionField}`}>Description*</span>
                                <TextField
                                    id="outlined-multiline-static"
                                    multiline
                                    name="description"
                                    className={classes.textBorderColor}
                                    placeholder="Enter Description"
                                    onChange={notificationFormik.handleChange}
                                    onBlur={notificationFormik.handleBlur}
                                    error={notificationFormik.touched.description && notificationFormik.errors.description}
                                    rows={9}
                                    value={notificationFormik.values.description}
                                    inputProps={{ maxLength: 300 }}
                                />
                                {
                                    notificationFormik.touched.description && notificationFormik.errors.description ? (
                                        <FormHelperText className={classes.inputError}>
                                            {notificationFormik.touched.description && notificationFormik.errors.description}
                                        </FormHelperText>
                                    ) : null
                                }
                                <span className={`${classes.characterCount} ${notificationFormik.touched.description && notificationFormik.errors.description ? classes.characterCountError : ''}`}>
                                    {notificationFormik.values.description.length} / 300
                                </span>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid spacing={2} container>
                        <Grid item xs={12} sm={12} lg={6} md={6}>
                            <FormControl fullWidth className={classes.inputContainer}>
                                <span className={classes.fieldLabels}>Choose Product*</span>
                                <FormControl fullWidth>
                                    <Select
                                        id="choose-product-select"
                                        value={notificationFormik.values.product}
                                        label="Product"
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                        }}
                                        name="product"
                                        onBlur={notificationFormik.handleBlur}
                                        onChange={notificationFormik.handleChange}
                                        className={classes.selectProduct}
                                        error={notificationFormik.touched.product && notificationFormik.errors.product}
                                    >
                                        <MenuItem value={0}>Choose Product</MenuItem>
                                        <MenuItem value={1}>SearchUnify</MenuItem>
                                        <MenuItem value={2}>Knowbler</MenuItem>
                                    </Select>
                                    {notificationFormik.touched.product && notificationFormik.errors.product ? (
                                        <FormHelperText className={classes.inputError}>
                                            {notificationFormik.touched.product && notificationFormik.errors.product}
                                        </FormHelperText>
                                    ) : null}
                                </FormControl>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} lg={6} md={6}>
                            <FormControl fullWidth className={classes.inputContainer}>
                                <span className={classes.fieldLabels}>Video URL</span>
                                <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder='Enter URL'
                                    value={notificationFormik.values.videoUrl}
                                    onChange={notificationFormik.handleChange}
                                    onBlur={notificationFormik.handleBlur}
                                    className={classes.textBorderColor}
                                    error={notificationFormik.touched.videoUrl && notificationFormik.errors.videoUrl}
                                    name="videoUrl"
                                    sx={{ marginTop: '4px' }}
                                />
                                {notificationFormik.touched.videoUrl && notificationFormik.errors.videoUrl ? (
                                    <FormHelperText className={classes.inputError}>
                                        {notificationFormik.touched.videoUrl && notificationFormik.errors.videoUrl}
                                    </FormHelperText>
                                ) : null}
                            </FormControl>
                        </Grid>
                    </Grid>

                    <FormControl fullWidth>
                        <span className={classes.fieldLabels}>Tenants*</span>
                        <Autocomplete
                            multiple
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option) => option.label}
                            options={tenants}
                            className={classes.autoCompleteField}
                            renderInput={(params) =>
                                <TextField
                                    name="clients"
                                    required
                                    {...params}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                border: '0.1px solid #d6d6d6 !important',
                                            },
                                        },
                                    }}
                                    className={classes.autoCompleteText}
                                    placeholder='Select Tenants'
                                    onBlur={notificationFormik.handleBlur}
                                    // value={notificationFormik.values.clients}
                                    // onChange={notificationFormik.handleChange}
                                    error={notificationFormik.touched.clients && Boolean(notificationFormik.errors.clients)}
                                />
                            }
                            value={notificationFormik.values.clients}
                            onChange={(event, newInputValue) => handleTenantChange(newInputValue)}
                        />
                        {notificationFormik.touched.clients && notificationFormik.errors.clients ? (
                            <FormHelperText className={classes.inputError}>
                                {notificationFormik.touched.clients && notificationFormik.errors.clients}
                            </FormHelperText>
                        ) : null}
                    </FormControl>

                    <FormControlLabel
                        control={
                            <Checkbox
                                color='primary'
                                checked={notificationFormik.values.priority}
                                className={classes.importantNotification}
                                onChange={notificationFormik.handleChange}
                                name="priority"
                            />
                        }
                        label={
                            <Typography
                                className={classes.importantNotificationLabel}
                            >
                                Mark as Important Notification
                            </Typography>}
                    />

                    {notificationFormik.values.product === 1 && (
                        <>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color='primary'
                                        checked={notificationFormik.values.sendEmail}
                                        className={classes.importantNotification}
                                        onChange={notificationFormik.handleChange}
                                        name="sendEmail"
                                    />
                                }
                                label={
                                    <Typography
                                        className={classes.importantNotificationLabel}
                                    >
                                        Send Email
                                    </Typography>}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color='primary'
                                        checked={notificationFormik.values.bannerEnabled}
                                        className={classes.importantNotification}
                                        onChange={notificationFormik.handleChange}
                                        name="bannerEnabled"
                                    />
                                }
                                label={
                                    <Typography
                                        className={classes.importantNotificationLabel}
                                    >
                                        Enable Banner
                                    </Typography>}
                            />
                        </>
                    )}
                    {notificationFormik.values.sendEmail && notificationFormik.values.product === 1 && (
                        <FormControl fullWidth className={classes.inputContainer}>
                            <div className={classes.uploadIconContainer}>
                                <span className={classes.fieldLabels}>Email Content*</span>
                                <Tooltip
                                    placement='right'
                                    title={
                                        <div style={{ fontSize: '12px', lineHeight: '1.6' }}>
                                            <p style={{ margin: '0 0 6px 0', fontWeight: 'bold' }}>Email Content Guidelines</p>
                                            <p style={{ margin: '0 0 4px 0' }}>• Use <strong>plain text</strong> OR <strong>full HTML</strong> — for consistent rendering</p>
                                            <p style={{ margin: '0 0 4px 0' }}>• Do not include <code>&lt;html&gt;</code>, <code>&lt;head&gt;</code>, or <code>&lt;body&gt;</code> tags</p>
                                            <p style={{ margin: '0 0 4px 0' }}>• Do not use <code>&lt;style&gt;</code> blocks — email clients strip them</p>
                                            <p style={{ margin: '0 0 4px 0' }}>• For styling use inline styles: <code>style=&quot;color: red&quot;</code></p>
                                            <p style={{ margin: 0 }}>• <code>&lt;video&gt;</code> tags are not supported in email clients</p>
                                        </div>
                                    }
                                >
                                    <InfoOutlined fontSize='small' style={{ cursor: 'pointer' }} />
                                </Tooltip>
                            </div>
                            <TextField
                                id="email-body"
                                multiline
                                name="emailBody"
                                className={classes.textBorderColor}
                                placeholder="Enter email body content (plain text or HTML)"
                                onChange={notificationFormik.handleChange}
                                onBlur={notificationFormik.handleBlur}
                                error={notificationFormik.touched.emailBody && notificationFormik.errors.emailBody}
                                rows={6}
                                value={notificationFormik.values.emailBody}
                                inputProps={{ maxLength: 5000 }}
                            />
                            {
                                notificationFormik.touched.emailBody && notificationFormik.errors.emailBody ? (
                                    <FormHelperText className={classes.inputError}>
                                        {notificationFormik.touched.emailBody && notificationFormik.errors.emailBody}
                                    </FormHelperText>
                                ) : null
                            }
                            <span className={`${classes.characterCount} ${notificationFormik.touched.emailBody && notificationFormik.errors.emailBody ? classes.characterCountError : ''}`}>
                                {notificationFormik.values.emailBody.length} / 5000
                            </span>
                        </FormControl>
                    )}


                    <div className={classes.buttonGroup}>

                        <Button
                            className={`${classes.notificationButton} ${classes.CancelButton}`}
                            onClick={() => props.history.push('/app/notifications')}
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            loading={buttonLoading}
                            loadingIndicator="Saving"
                            variant='outlined'
                            className={`${classes.notificationButton} ${classes.savePreviewButton}`}
                            disabled={!(notificationFormik.isValid && notificationFormik.dirty && notificationFormik.values.title?.trim() && notificationFormik.values.description?.trim())}
                            onClick={notificationFormik.submitForm}
                        >
                            {!buttonLoading && 'Save & Preview'}
                        </LoadingButton>
                        <Button
                            className={classes.draftButton}
                            variant="outlined"
                            endIcon={
                                <IconButton
                                    size='small'
                                    className={classes.publishIcons}
                                    onClick={handleSchedulePopupClick}
                                    disabled={!(notificationFormik.isValid && notificationFormik.dirty && notificationFormik.values.title?.trim() && notificationFormik.values.description?.trim())}
                                >
                                    {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                </IconButton>
                            }
                            aria-controls={open ? 'schedule-menu' : undefined}
                            aria-haspopup="true"
                            onClick={() => setPublishModal(true)}
                            aria-expanded={open ? 'true' : undefined}
                            disabled={!(notificationFormik.isValid && notificationFormik.dirty && notificationFormik.values.title?.trim() && notificationFormik.values.description?.trim())}
                        >
                            Publish
                        </Button>
                        <Menu
                            id="schedule-menu"
                            anchorEl={scheduleAnchorEl}
                            open={open}
                            onClose={handleCloseMenu}
                            MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                        >
                            <MenuItem dense onClick={() => publishNowNotification(new Date().toISOString(), 'draft')}>Save as Draft</MenuItem>
                        </Menu>
                    </div>
                </form>
            </div>

            <Publish
                open={publishModal}
                handleClose={() => setPublishModal(false)}
                handleSubmit={publishNowNotification}
                savedScheduleDate={savedScheduleDate}
                loading={modalButtonLoading}
                notificationStatus={notificationStatus}
            />
        </div>

    );
};

export default CreateNotification;